"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var theme = _a.theme, gridGap = _a.gridGap;
    if (!gridGap) {
        return '';
    }
    if (Array.isArray(gridGap) && gridGap.length <= 2) {
        return "gap: " + gridGap.map(function (size) { return theme.sizes.default[size] || 'auto'; }).join(' ') + ";";
    }
    console.error('Please provide an array (max 2 elements) for `gridGap` style helper.');
    return '';
});
